import React from 'react';
import { ResultsHeader } from './ResultsHeader';
import { useResultsHeaderData } from '../../../hooks/useResultsHeaderData';

type FacetItem = {
  label: string;
  value: string;
  count: number;
  isRefined: boolean;
};

type Props = {
  facetBuckets: FacetItem[];
  nbHits: number;
  align?: 'left' | 'center' | 'right';
};

const ResultsHeaderLive: React.FC<Props> = ({
  facetBuckets,
  nbHits,
  align,
}) => {
  const { trimmedQuery, activeFacet, initialHitCount } = useResultsHeaderData(
    facetBuckets,
    nbHits,
  );

  if (!trimmedQuery) return null;

  return (
    <div data-testid="results-header-live" data-align={align}>
      <ResultsHeader
        query={trimmedQuery}
        activeFacet={activeFacet}
        initialHitCount={initialHitCount}
        align={align}
      />
    </div>
  );
};

export default ResultsHeaderLive;
